import React from 'react';

export type AuthMethod = 'email' | 'google' | 'anonymous';

interface AuthMethodDisplayProps {
  method: AuthMethod;
  isVerified?: boolean;
  email?: string;
  showVerifiedBadge?: boolean;
}

const AuthMethodDisplay: React.FC<AuthMethodDisplayProps> = ({
  method,
  isVerified = true,
  email,
  showVerifiedBadge = true
}) => {
  const getMethodConfig = () => {
    switch (method) {
      case 'google':
        return {
          icon: '🔵',
          label: 'Google',
          description: 'Signed in with Google account'
        };
      case 'anonymous':
        return {
          icon: '👤',
          label: 'Guest',
          description: 'Anonymous guest account'
        };
      case 'email':
      default:
        return {
          icon: '✉️',
          label: 'Email',
          description: 'Signed in with email and password'
        };
    }
  };

  const config = getMethodConfig();

  return (
    <div>
      <div className="flex items-center space-x-2">
        <span className="text-lg">{config.icon}</span>
        <span className="text-gray-900 font-medium">{config.label}</span>
        {method !== 'anonymous' && showVerifiedBadge && isVerified && (
          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
            Verified
          </span>
        )}
      </div>
      
      {email && (
        <div className="mt-1 text-sm text-gray-500">{email}</div>
      )}
      
      <div className="mt-1 text-sm text-gray-500">
        {config.description}
      </div>
    </div>
  );
};

export default AuthMethodDisplay; 